// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2mCOO","name":"ConsentHeader_name__KWUW8","birthday":"ConsentHeader_birthday__3uK3v","skeleton":"ConsentHeader_skeleton__13PES"};